import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getActiveProductSurvey } from '../../services/productSurveys.service';
import { useProductSurveyScope } from './session';

export function useActiveProductSurvey() {
  const scope = useProductSurveyScope();
  const client = useQueryClient();
  const query = useQuery({
    queryKey: scope.queryKey, enabled: scope.enabled, staleTime: 5 * 60_000, retry: false,
    meta: { silent: true },
    queryFn: async ({ signal }) => {
      if (!scope.isCurrentSession() || !scope.token) throw new Error('Session changed');
      const response = await getActiveProductSurvey(scope.token, signal);
      if (!scope.isCurrentSession()) throw new Error('Session changed');
      if (response.data?.data?.survey === undefined) throw new Error('Invalid survey response');
      return response.data.data.survey;
    },
  });
  const endsAt = query.data?.endsAt;
  useEffect(() => {
    if (!endsAt) return;
    const remaining = Date.parse(endsAt) - Date.now();
    // A single expiry timer, never polling. Longer lifetimes revalidate through normal cache usage.
    if (remaining > 2_147_483_647) return;
    const timer = setTimeout(() => { client.setQueryData(scope.queryKey, null); }, Math.max(0, remaining));
    return () => clearTimeout(timer);
  }, [client, scope.queryKey, endsAt]);
  return { ...query, sessionKey: scope.sessionKey,
    data: scope.enabled && !query.isError && (!endsAt || Date.parse(endsAt) >= Date.now()) ? query.data : null };
}
